import React, { createContext, useState } from "react";
import WidgetService from "../Services/widgetService";

const Context = createContext();

const Provider = ({ children }) => {
  const [campaign, setCampaign] = useState("");
  const [server, setServer] = useState("");

  const getLayout = async (carouselName) => {
    let campaignTemp = campaign;
    let serverTemp = server;

    if (!campaignTemp || !serverTemp) {
      const response = await WidgetService.configProject({
        carousel: carouselName,
      });

      if (response?.data?.campaign) {
        campaignTemp = response?.data?.campaign;
        setCampaign(response?.data?.campaign);
      }

      if (response?.data?.server) {
        serverTemp = response?.data?.server;
        setServer(response?.data?.server);
      }
    }

    let response = null;
    if (serverTemp === "ai") {
      response = await WidgetService.layoutAi({ campaign: campaignTemp });
    } else if (serverTemp === "app") {
      response = await WidgetService.layoutApp({ campaign: campaignTemp });
    }

    if (response?.data?.text) {
      return response?.data;
    }
  };

  return (
    <Context.Provider
      value={{
        campaign,
        getLayout,
        server,
        setCampaign,
        setServer,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export { Provider, Context };
